import { getSchool, getAssessmentRegime } from '../Api'

/**
 * Busca e grava no sessionStorage o assessmentFormat e o assessmentRegime
 * de uma escola. Use no login, no preload e na seleção de escola.
 *
 * IMPORTANTE: requer que o token JÁ esteja no header da api
 * (api.defaults.headers.Authorization), pois getSchool e getAssessmentRegime
 * são rotas protegidas — sem o token elas retornam 401.
 *
 * Não crítico: qualquer falha é engolida (apenas logada) para não travar
 * o fluxo de autenticação.
 *
 * @param {string} idSchool - id da escola (valor cru, sem JSON.stringify)
 * @returns {Promise<{assessmentFormat: string, assessmentRegime: string}>}
 */
export async function loadSchoolAssessmentInfo(idSchool) {
    let assessmentFormat = ''
    let assessmentRegime = ''

    if (!idSchool) return { assessmentFormat, assessmentRegime }

    const [schoolRes, regimeRes] = await Promise.allSettled([
        getSchool(idSchool),
        typeof getAssessmentRegime === 'function'
            ? getAssessmentRegime(idSchool)
            : Promise.resolve(null),
    ])

    if (schoolRes.status === 'fulfilled') {
        assessmentFormat = schoolRes.value?.data?.data?.assessmentFormat ?? ''
    } else {
        console.error('Falha ao buscar assessmentFormat:', schoolRes.reason)
    }

    if (regimeRes.status === 'fulfilled') {
        assessmentRegime = regimeRes.value?.data?.data ?? ''
    } else {
        console.error('Falha ao buscar assessmentRegime:', regimeRes.reason)
    }

    if (assessmentFormat) sessionStorage.setItem('assessmentFormat', assessmentFormat)
    if (assessmentRegime) sessionStorage.setItem('assessmentRegime', assessmentRegime)

    return { assessmentFormat, assessmentRegime }
}